export default function PathwaysController() {}
